import React from 'react';

export const Info2 = (props: any) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
    <path
      fillRule="evenodd"
      d="M20 11.53c4.678 0 8.47 3.792 8.47 8.47 0 4.678-3.792 8.47-8.47 8.47-4.678 0-8.47-3.792-8.47-8.47 0-4.678 3.792-8.47 8.47-8.47zm0 1.411c-3.898 0-7.059 3.16-7.059 7.059 0 3.898 3.16 7.059 7.059 7.059 3.898 0 7.059-3.16 7.059-7.059 0-3.898-3.16-7.059-7.059-7.059zm0 5.647c.37 0 .672.284.703.645l.003.061v4.235c0 .39-.316.706-.706.706-.37 0-.672-.283-.703-.645l-.003-.06v-4.236c0-.39.316-.706.706-.706zm0-2.823c.39 0 .706.316.706.706 0 .39-.316.705-.706.705-.39 0-.706-.316-.706-.705 0-.39.316-.706.706-.706z"
    />
  </svg>
);
